import React from "react";
import { useTranslation } from "react-i18next";
import ArticlesTable from "./ArticlesTable";

const Article = ({
  quantityMsg,
  setQuantityMsg,
  modalValidationMsg,
  setModalValidationMsg,
  products,
  values,
  setProducts,
  setShowProductModal,
  setShowFilterModal,
}) => {
  const { t: translator } = useTranslation();

  return (
    <div className="col-lg-8">
      <fieldset className="scheduler-border">
        <legend className="scheduler-border">
          {translator("InitialState-Items")}
        </legend>
      </fieldset>

      <div className="form-group mt-4">
        <button
          className="btn btn-outline-secondary"
          disabled={values.storeId === 0}
          type="button"
          onClick={(e) => {
            e.preventDefault();
            if (document.getElementsByName("storeId")[0].value === "") {
              setModalValidationMsg("ValidationMsg-SelectStore");
            } else setShowFilterModal(true);
          }}
        >
          <span className="icon icon-filter"></span> {translator("Filter")}
        </button>
        &nbsp;
        {/* <button
               className="btn btn-primary"
               disabled={values.storeId === 0}
               type="button"
               onClick={(e) => {
                  e.preventDefault();
                  if (document.getElementsByName("storeId")[0].value === "") {
                     setModalValidationMsg("ValidationMsg-SelectStore");
                  } else setShowProductModal(true);
               }}
            >
               {translator("InitialState-AddProduct")}
            </button> */}
        <span className="text-danger ml-2">
          {translator(modalValidationMsg)}
        </span>
      </div>
      <ArticlesTable
        products={products}
        setProducts={setProducts}
        quantityMsg={quantityMsg}
        setQuantityMsg={setQuantityMsg}
      />
    </div>
  );
};

export default Article;
